// De qué lado de su pastilla se abre el panel de la fila (la Inteligencia y el engranaje) —
// ADR-2026-09-25-el-panel-de-las-pastillas-abre-hacia-donde-hay-lugar.
//
// El panel colgaba SIEMPRE debajo de la pastilla: pensado para la caja de la home, que
// está en el medio de la pantalla. En el Agente la caja vive al pie y abajo no queda
// nada, así que el panel nacía contra el borde y casi no se veía. La regla es la del
// popover de verificación (ADR-2026-09-09-el-popover-nunca-queda-cortado): abajo si
// entra, arriba si entra, y si no entra en ninguno, del lado con más aire (el panel
// scrollea adentro). Puro.

export type LadoDelPanel = 'abajo' | 'arriba';

export function ladoDelPanel(p: {
  /** Lo que hay entre el borde de abajo de la pastilla y el piso, descontado el aire. */
  espacioAbajo: number;
  /** Lo que hay entre el borde de arriba de la pastilla y el techo, descontado el aire. */
  espacioArriba: number;
  /** El alto que pide el contenido del panel; `null` antes de que se monte. */
  altoContenido: number | null;
}): LadoDelPanel {
  const { espacioAbajo, espacioArriba, altoContenido } = p;
  if (altoContenido !== null && altoContenido > 0) {
    if (altoContenido <= espacioAbajo) return 'abajo';
    if (altoContenido <= espacioArriba) return 'arriba';
  }
  return espacioAbajo >= espacioArriba ? 'abajo' : 'arriba';
}
